import React from 'react';
import { useMeasurement, useSirenEntity } from '~/utility/BinSentry-ui-utility';
import { makeStyles } from '~/lib/bn-material-ui';

const useStyles = makeStyles(() => ({
  snackbarHeader: {
    fontWeight: 'bold',
  },
}));

export const OrdersDialogSnackbarMessage = ({ orderEntity, integrationMessage, actionVerb }) => {
  const styles = useStyles();
  const orderMeasurement = useMeasurement({ name: 'orderAmount' });
  const { entity: feedEntity } = useSirenEntity({ href: orderEntity?.getSubEntityByRel('https://api.binsentry.com/rel/feed').href });
  const orderAmount = orderMeasurement.convert({
    volume: orderEntity?.properties.quantity,
    bulkDensity: feedEntity?.properties?.bulkDensity,
  });
  const { entity: barnEntity } = useSirenEntity({ href: orderEntity?.getLinkByRel('https://api.binsentry.com/rel/barn').href });
  const { entity: farmEntity } = useSirenEntity({ href: barnEntity?.getLinkByRel('https://api.binsentry.com/rel/farm').href });

  return <div>
    <div className={styles.snackbarHeader}>Order {actionVerb}</div>
    {orderEntity && <>
      <div>{orderAmount} {orderMeasurement.unit} Order {actionVerb} {integrationMessage ? `and ${integrationMessage}` : 'for'}:</div>
      <div>{`${farmEntity?.properties.name} > ${barnEntity?.properties.name}`}</div>
    </>}
  </div>;
};

